import { IFrameworkBaseEnitity } from "./framework-base-entity.interface";

export enum GOA_EVENT_ENTRY_TYPE {
  THEFT = "THEFT",
  JACKPOT_RAISED = "Jackpot Raised",
  CASH_PULL = "Cash Pull",
  CASH_PULL_LOWERCASE = "Cash pull", // Note: you have two entries that are very similar
  CHANGED_PAYOUT_SETTING_TO_LOW = "Changed payout setting to low",
  GOA_ONLINE = "GoA online",
  RECEIVED_GOA_MACHINE = "Received GoA machine",
  INSTALLED_TRK = "Installed TRK",
  INSTALLED_GOA = "Installed GoA",
  CASH_PULL_UPPERCASE = "Cash PULL", // Note: you have two entries that are very similar
  METER_CHECK_ONLY = "Meter Check Only",
  WIRE_IN_METERS = "Wire in meters",
  RECEIVED_GOA_MACHINE_CAPITALIZED = "Received GoA Machine",
  TRK_ONLINE = "TRK online",
  MACHINE_LEVELS_ADJUSTED = "Machine Levels Adjusted",
  UNSERVICEABLE = "Unserviceable",
}

export interface IGoaEvent extends IFrameworkBaseEnitity {
    date?: Date;
    time?: string;
    location?: string;
    assetId?: string;
    statusChange?: string;
    event?: string;
    eventOther?: string; 
    hardIn?: number; 
    hardOut?: number; 
    moneyIn?: number;
    moneyOut?: number; 
    technician?: string;
    resolveTime?: string;
    resolveDate?: Date;
    game?: string;
    maxBet?: number;
    payoutLevel?: string;
    mini?: number;
    minor?: number;
    major?: number;
    grand?: number;
    goaId?: number;
    locationVisitId?: number;
    notes?: string;
    serviceIssue?: string;
  }